var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('footer',{staticClass:"footer has-background-grey-lighter"},[_c('div',{staticClass:"content has-text-centered"},[_c('p',{staticClass:"footer-copy"},[_vm._v("© Tokyo Fabric Industry Co.,Ltd. All Rights Reserved.")])])])
}]

export { render, staticRenderFns }